import api from './api';

const ENDPOINT = 'banners';

const BannersService = {
  get: (params = null) => api.get(ENDPOINT, { params }),
  getId: (id) => api.get(`${ENDPOINT}/${id}`),
  save: (data) => api.post(`${ENDPOINT}`, data),
  update: (id, data) => api.put(`${ENDPOINT}/${id}`, data),
  delete: (id) => api.delete(`${ENDPOINT}/${id}`),
  reorder: (bannerId, order) =>
    api.put(`${ENDPOINT}/${bannerId}/reorder`, { order }),
  moveUp: (bannerId) => api.put(`${ENDPOINT}/${bannerId}/move-up`, null),
};

export default BannersService;
